import React from 'react'
import PropTypes from 'prop-types'

import Box from 'suitTheme/Box'

const Grid = React.forwardRef((props, ref) => {
  const { children } = props

  return (
    <Box display="grid" {...props} ref={ref}>
      {children}
    </Box>
  )
})

Grid.propTypes = {
  children: PropTypes.node,
}

export default Grid
